import { Button, Drawer } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "../../common/Loader";
import { PlusOutlined } from "@ant-design/icons";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { authenticateToken } from "../../../utils/auth";
import PaginationTwo from "../../common/PaginationTwo";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import AddSalesMan from "./AddSalesMan";

const ShopSalesManList = ({ params }: any) => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [limit, setLimit] = useState(16);
  const [visible, setvisible] = useState<boolean>(false);

  const [selectedSalesMan, setSelectedSalesMan] = useState(undefined);
  const [selectedSlalesManForEdit, setSelectedSlalesManForEdit] =
    useState(undefined);
  const [shopSlalesManData, setShopSlalesManData] = useState({
    loading: false,
    data: null,
  });
  const route = useParams();

  const getShopSalesMan = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setShopSlalesManData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/sales-man?shopId=${getShopId}` +
              (type ? `?type=${type}` : ``) +
              (status ? `?status=${status}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setShopSlalesManData({
                loading: false,
                data: data?.data,
              });
            } else {
              setShopSlalesManData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setShopSlalesManData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setShopSlalesManData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    getShopSalesMan((route as any)?.shopId);
  }, [getShopSalesMan, (route as any)?.shopId]);

  useEffect(() => {
    if (visible) {
      setSelectedSalesMan(undefined);
      setSelectedSlalesManForEdit(undefined);
    }
  }, [selectedSalesMan, selectedSlalesManForEdit]);

  useEffect(() => {
    setSelectedSalesMan(undefined);
    setSelectedSlalesManForEdit(undefined);
  }, [visible]);

  const showDrawer = () => {
    setvisible(true);
  };

  const onClose = () => {
    setvisible(false);
    setSelectedSalesMan(null);
    setSelectedSlalesManForEdit(null);
    getShopSalesMan((route as any)?.shopId);
  };
  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="product-list-item-area white-bg">
          <ShopHeader
            leftarea={"Sales Man List"}
            rightarea={
              <Button
                danger
                type="primary"
                icon={<PlusOutlined />}
                title="Add New"
                onClick={showDrawer}
              >
                Add New
              </Button>
            }
          />
          <div className="product-list-items-inner-content">
            <div className="single-product-wrapper">
              <div className="single-product-heading">
                <span>Sales Man</span>
              </div>
              <div className="single-product-heading">
                <span>Phone Number</span>
              </div>
              <div className="single-product-heading">
                <span>Balance</span>
              </div>
            </div>
          </div>

          {shopSlalesManData?.loading ? (
            <Loading />
          ) : (
            <div className="product-table">
              <div className="product-table-area">
                {shopSlalesManData?.data?.salesMan?.length ? (
                  shopSlalesManData?.data?.salesMan?.map(
                    (salesman: any, index: number) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedSalesMan(salesman.id)}
                        >
                          <div className="single-product">
                            <span className="name">{salesman?.name}</span>
                          </div>

                          <div className="single-product">
                            <span className="name">
                              {salesman?.mobileNumber?.replace("+88", "")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              &#2547;{parseInt(salesman?.balance || 0)}
                            </span>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  )
                ) : (
                  <Empty data="Sales Man!" />
                )}
              </div>
            </div>
          )}

          {/* <Drawer
            title={
              selectedSlalesManForEdit
                ? "Edit Sales Man"
                : "Sales Man Add"
            }
            width={800}
            onClose={onClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
              <AddSalesMan
                visibleData={selectedSlalesManForEdit}
                onCloseMethod={onClose}
              />
          </Drawer> */}

          <Drawer
            destroyOnClose={true}
            title="Add New"
            width={600}
            onClose={onClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddSalesMan onCloseMethod={onClose} />
          </Drawer>

          <PaginationTwo
            {...shopSlalesManData.data}
            limit={limit}
            page={shopSlalesManData?.data?.currentPageNumber || 0}
          />
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default ShopSalesManList;
